export const ChildCustomView = (Data) => {
    return {
        type: 'ChildCustomViewAction',
        payload: Data
    }
}